define(function (require) {
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpUtils = require('utils/lpUtils');
    var BaseApiService = require('web-agent-utils/BaseApiService');

    var AppInstall = function () {
        this.applicationType = "AppInstall";

        var accountConfigResources = agentLEManager.getLEUrlResolverApiResourcesService("AccountConfig");
        var appInstallApiResource, getAllAdditionalUrl, getSingleAdditionalUrl;

        if (accountConfigResources && accountConfigResources[this.applicationType]) {
            var fullResourceUrl = agentLEManager.getLEUrlResolverGetUrl(accountConfigResources[this.applicationType]);
            var resourceDomainUrl = lpUtils.getSubDomain(fullResourceUrl);
            getAllAdditionalUrl = fullResourceUrl.substring(resourceDomainUrl.length);
            if (getAllAdditionalUrl.indexOf("?") >= 0) {
                getSingleAdditionalUrl = getAllAdditionalUrl.replace("?", "/{appInstallId}?");
            } else {
                getSingleAdditionalUrl = getAllAdditionalUrl + "/{appInstallId}";
            }
            appInstallApiResource = BaseApiService.createInstance({
                domainUrl: resourceDomainUrl,
                postmessagePath: "/postmessage",
                serviceName: this.applicationType
            });
        }

        function _createRequest(reqObj, appInstallId) {
            reqObj.method = 'GET';
            reqObj.additionalUrl = getSingleAdditionalUrl.replace("{appInstallId}", appInstallId);
            reqObj.callingFunction = 'getAppInstall';
            reqObj.splitRevisionBy = 'additionalUrl';
            return reqObj;
        }

        this.getRequest = function (reqObj, appInstallId) {
            reqObj = _createRequest(reqObj, appInstallId);
            return appInstallApiResource.createBasicRequest(reqObj);
        };

        this.getAppInstall = function (reqObj, appInstallId) {
            reqObj = _createRequest(reqObj, appInstallId);
            appInstallApiResource.sendRequest(reqObj);
        };
    };
    return AppInstall;
});
